
import { RevLink } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'

import translations from './Litterature.translations'

export default {
  components: {
    RevLink,
    FormattedMessage,
  },

  computed: {
    ...mapGetters({
      warrantyDuration: 'config/warrantyDuration',
    }),

    translations: () => translations,
    ROUTES: () => ROUTES,
  },
}
